import type { ReactNode } from "react"

import { JSX } from "react/jsx-runtime"

import { ErrorIcon } from "@/3514/assets"
import { THEME } from "@/3514/theme"

import { type TInfoBoxVariant, type TInfoBoxVariant as TVariant } from "./info-box.types"

import IntrinsicElements = JSX.IntrinsicElements

function cutSpacesFromHTMLString(source: string): string {
    return source.replace(/>\s+</g, "><")
}

function getClassesForRichText(cssIdentifier: string): string {
    return `
        .${cssIdentifier} * { 
          color: ${THEME.COLORS.gray[100]};
          font-weight: ${THEME.FONT_WEIGHTS[300]};
          line-height: ${THEME.LINE_HEIGHTS[21]}px;
          font-size: ${THEME.FONT_SIZES[14]}px;
          white-space: pre-line;
        }
        .${cssIdentifier} a, .${cssIdentifier} u { 
          text-decoration: underline; 
          text-underline-offset: 3px; 
        }
        .${cssIdentifier} a { 
          color: ${THEME.COLORS.accent}; 
        }
        .${cssIdentifier} a:hover, .${cssIdentifier} a:focus { 
          text-underline-offset: 5px;
          outline: none;
        }
        .${cssIdentifier} i { font-style: italic; }
        .${cssIdentifier} strong, .${cssIdentifier} b { font-weight: ${THEME.FONT_WEIGHTS[800]}; }
        .${cssIdentifier} p, 
        .${cssIdentifier} ul, .${cssIdentifier} ol { margin-bottom: 0px; }
        .${cssIdentifier} ul, .${cssIdentifier} ol { list-style-position: inside; }
        .${cssIdentifier} ul { list-style-type: disc; }
        .${cssIdentifier} ol { list-style-type: decimal; }
    `
}

const rendererAllowedTags: (keyof IntrinsicElements)[] = [
    "p",
    "span",
    "strong",
    "a",
    "b",
    "u",
    "i",
    "ul",
    "ol",
    "li",
    "br"
]

const variantIcons: Record<TInfoBoxVariant, ReactNode> = {
    warning: <div className="scale-[0.8]">⚠️</div>,
    error: <ErrorIcon />,
    info: <div className="scale-[0.8]">⏳️</div>
}

const variantDismissIconColor: Record<TVariant, string> = {
    warning: THEME.COLORS.red[200],
    error: THEME.COLORS.red[200],
    info: THEME.COLORS.lightblue[100]
}

export default {
    cutSpacesFromHTMLString,
    getClassesForRichText,
    rendererAllowedTags,
    variantIcons,
    variantDismissIconColor
}
